import { motion } from "framer-motion";
import { SOFTWARE } from "@/data/site";

const fade = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 1, ease: [0.16, 1, 0.3, 1] } },
};

export default function About() {
    return (
        <section id="about" data-testid="about-section" className="relative border-t border-white/5 bg-[#070708] px-5 sm:px-10 py-24 sm:py-36">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
                <motion.div
                    variants={fade}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                    className="lg:col-span-7"
                >
                    <p className="font-mono-x text-[10px] sm:text-xs tracking-[0.4em] text-[#FF3333] mb-6">
                        THE STUDIO
                    </p>
                    <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tighter leading-[0.95]">
                        Indie passion to{" "}
                        <span className="text-outline">blockbuster scale</span> - on time, on budget
                    </h2>
                    <p className="mt-8 max-w-xl text-sm sm:text-base leading-relaxed text-neutral-400">
                        EXODUS FX is a boutique visual effects studio based in Atlanta and New York. Our artists bring
                        more than 30 years of experience, with nominations and wins from BAFTA, EMMY and VES. Operating
                        entirely remote, we scale the perfect team to every production - from concept design and matte
                        painting to intricate compositing and dynamic simulations.
                    </p>
                    <div
                        data-testid="about-tpn-badge"
                        className="mt-10 flex w-fit items-center gap-5 border border-white/10 bg-white/[0.02] px-6 py-4 hover:border-white/25 transition-colors duration-500"
                    >
                        <img
                            src="/images/tpn.png"
                            alt="TPN Trusted Partner Network"
                            data-testid="about-tpn-logo"
                            className="h-9 w-auto opacity-90"
                        />
                        <span className="font-mono-x text-[10px] tracking-[0.35em] text-neutral-400">
                            TPN TRUSTED
                        </span>
                    </div>
                </motion.div>

                <motion.div
                    variants={fade}
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ delay: 0.15 }}
                    className="lg:col-span-5 flex flex-col justify-center gap-8"
                >
                    <div className="border-l-2 border-[#FF3333] pl-6">
                        <p data-testid="about-stat-shots-delivered" className="font-display text-5xl sm:text-6xl font-extrabold tracking-tighter">
                            800<span className="text-[#FF3333]">+</span>
                        </p>
                        <p className="font-mono-x text-[10px] tracking-[0.3em] text-neutral-500 mt-2">
                            SHOTS DELIVERED IN 2024 / SIX PROJECTS
                        </p>
                    </div>
                    <div className="border-l-2 border-white/15 pl-6">
                        <p data-testid="about-stat-awards-nominations" className="font-display text-5xl sm:text-6xl font-extrabold tracking-tighter">
                            30<span className="text-[#FF3333]">+</span>
                        </p>
                        <p className="font-mono-x text-[10px] tracking-[0.3em] text-neutral-500 mt-2">
                            YEARS - BAFTA / EMMY / VES NOMINATED ARTISTS
                        </p>
                    </div>
                </motion.div>
            </div>

            <motion.div
                variants={fade}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}
                className="mt-16 sm:mt-24"
            >
                <p className="font-mono-x text-[10px] tracking-[0.4em] text-neutral-500 mb-6">THE STACK</p>
                <div className="flex flex-wrap gap-3">
                    {SOFTWARE.map((tool) => (
                        <span
                            key={tool}
                            data-testid={`about-software-badge-${tool.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                            className="font-mono-x text-[10px] sm:text-[11px] tracking-[0.25em] text-neutral-400 border border-white/10 hover:border-[#FF3333]/60 hover:text-white px-4 py-2 transition-colors duration-300 cursor-default"
                        >
                            {tool}
                        </span>
                    ))}
                </div>
            </motion.div>
        </section>
    );
}
